<div data-test="XDP8A5gX" class="labels">
  <div data-test="lrQYM-zz" class="labels__wrapper">
    <div data-test="lSk3xWml" *ngFor="let tag of tags" class="labels__item">
      <div data-test="XoKBZGFl" class="label label_lightgray">
        <span data-test="vcloFzss">{{ tag.name }}</span>
        <span data-test="ah4Oj_Zs" class="label__append" data-label="remove">
          <i
            data-test="yggZ0M1O"
            (click)="removeTag(tag)"
            class="material-icons md-12 ml-1"
          >
            close
          </i>
        </span>
      </div>
    </div>

    <div data-test="L_qP8C2F" class="labels__item">
      <md-dropdown
        data-test="L6cLyn62"
        dropdownClasses="dropdown_child"
        [url]="ListsUrls.Tags"
        inputClasses="input_sm"
        (optionChange)="addTag($event)"
        labelKey="name"
        valueKey="uuid"
        [canAdd]="true"
        placeholder="Enter tag name"
        [canCreate]="true"
        [autoWidth]="true"
        [canClearInputValue]="true"
        [filterOptionsFn]="createTagsFilter()"
        [disableCache]="true"
      >
        <ng-template mdTemplate="selected">
          <div
            data-test="qc3dEyOp"
            class="label label_yellow"
            data-dropdown="#add-new-tag"
          >
            <i data-test="ZZpFIp-k" class="material-icons md-12 mr-1">add</i>
            <span data-test="MxXkz1ng">Add Tag</span>
          </div>
        </ng-template>
      </md-dropdown>
    </div>
  </div>
</div>
